import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { formatCreationDate, formatLocalTime } from "~/utils/date.jsx";
import { getPersonalizedDateFormat, getPersonalizedTimeFormat } from "../../store/selectors/selector.configOptions.jsx";

export const FormatSmartLocalDateTime = ({ value, long }) => {
  const dateFormat = useSelector(getPersonalizedDateFormat);
  const timeFormat = useSelector(getPersonalizedTimeFormat);

  const formattedValue = useMemo(() => {
    return formatCreationDate(value, dateFormat, long) + ", " + formatLocalTime(value, timeFormat);
  }, [value, long, dateFormat, timeFormat]);

  return formattedValue;
};

FormatSmartLocalDateTime.propTypes = {
  value: PropTypes.number.isRequired,
  long: PropTypes.bool,
};

FormatSmartLocalDateTime.defaultProps = {
  long: false,
};
